(function () {
  var STORAGE_KEY = 'promoBottomBarDismissed';
  var bar = document.querySelector('.promo-bottom-bar');
  if (!bar) return;

  // On non-live themes the dismissal isn't remembered (bar returns on
  // refresh), so it stays testable while editing.
  var persistDismiss = !bar.hasAttribute('data-no-persist-dismiss');

  if (persistDismiss && sessionStorage.getItem(STORAGE_KEY) === 'true') {
    bar.hidden = true;
    return;
  }

  // Display timing. "after_popup" makes this bar Postscript's teaser
  // replacement: stay hidden until their popup is dismissed (or a subscriber
  // is created), then appear. Falls back to showing anyway if the SDK never
  // reports in, so the bar can't get stranded when Postscript is blocked or
  // absent. Events per https://developers.postscript.io/docs/sdk-events
  var dismissed = false;

  if (bar.getAttribute('data-display-timing') === 'after_popup') {
    var reveal = function () {
      if (dismissed) return;
      bar.hidden = false;
    };
    // Rendered hidden by Liquid to avoid a flash before this runs.
    var onPopup = function (e) {
      var type = e.detail && e.detail.type;
      // The loop: popup shows -> visitor closes it (X, "No thanks", or signs
      // up) -> bar appears. Tapping the bar reopens the popup; closing it
      // brings the bar back. "skipped" means the popup won't open this visit
      // (dismissed recently), so the bar shows immediately.
      if (type === 'close' || type === 'subscriberCreated' || type === 'skipped') reveal();
    };
    window.addEventListener('fmSignupPopup', onPopup);
    window.addEventListener('postscriptPopup', onPopup);

    // Safety net only when the theme's own popup isn't on the page (e.g.
    // disabled in the editor) — then there's no event to wait for. With the
    // theme popup present the bar waits for it, however long that takes.
    if (!document.querySelector('[data-fm-popup]')) setTimeout(reveal, 20000);
  }

  var closeButton = bar.querySelector('.promo-bottom-bar__close');
  var bodyButton = bar.querySelector('.promo-bottom-bar__body');
  var textEl = bar.querySelector('.promo-bottom-bar__text');
  var originalText = textEl ? textEl.textContent : '';
  var code = bar.getAttribute('data-coupon-code');

  closeButton.addEventListener('click', function () {
    dismissed = true;
    bar.hidden = true;
    if (persistDismiss) sessionStorage.setItem(STORAGE_KEY, 'true');
  });

  if (code) {
    bodyButton.addEventListener('click', function () {
      navigator.clipboard.writeText(code).then(function () {
        if (!textEl) return;
        textEl.textContent = 'Copied!';
        setTimeout(function () {
          textEl.textContent = originalText;
        }, 1500);
      });
    });
  } else {
    // No static coupon configured: the bar is the tap target that spawns
    // Postscript's signup popup (their mobile and desktop popups are the
    // bespoke ones; this bar only replaces their teaser bubble, which
    // block-postscript-teaser.js hides). Falls back to the theme's own popup
    // when the SDK isn't on the page.
    // https://developers.postscript.io/docs/javascript-sdk-api-reference
    bodyButton.addEventListener('click', function () {
      var ps = window.postscript;
      var fallback = function () { if (window.fmSignupPopup) window.fmSignupPopup.open(); };
      if (!ps || !ps.popups || typeof ps.popups.open !== 'function') { fallback(); return; }
      var fixed = bar.getAttribute('data-postscript-popup-id');
      var lookup = fixed
        ? Promise.resolve(fixed)
        : Promise.resolve(ps.popups.find({ respectPage: false, respectSubscriber: false, respectCountry: false, respectStatus: false }));
      lookup.then(function (popup) {
        // find() resolves to an id per the docs; tolerate an object too.
        var id = popup && typeof popup === 'object' ? (popup.id || popup.popupId) : popup;
        if (!id) { fallback(); return; }
        return ps.popups.open(id, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: false, respectCooldown: false });
      }).catch(fallback);
    });
  }
})();
